import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormControlComponent, DynamicFormControlCustomEvent, DynamicFormLayoutService, DynamicFormValidationService } from '@ng-dynamic-forms/core';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { SoudotecEmplacementInputModel } from './soudotec-emplacement-input.model';

@Component({
  selector: 'dynamic-soudotec-emplacement-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-soudotec-emplacement-input.component.html'
})
export class DynamicSoudotecEmplacementInputComponent extends DynamicFormControlComponent {
  @Input() bindId = true;
  @Input() group: FormGroup;
  @Input() model: SoudotecEmplacementInputModel;
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();
  COMPONENT_MODE = COMPONENT_MODE; 
  constructor(protected layoutService: DynamicFormLayoutService, protected validationService: DynamicFormValidationService) {
    super(layoutService, validationService);
  }
}
